import { SuggestPage } from './SuggestPage';
export default SuggestPage;
